import React, { useState } from 'react'
import InventoryTable from './InventoryTable'
import InventoryTabsHeader from '../InventoryTabsHeader'
import InventoryTabsContent from '../InventoryTabsContent'

function InventoryTab(props) {
  const [searchText, setSearchText] = useState('')

  const onSearch = searchText => {
    setSearchText(searchText)
  }

  return (
    <div>
      <InventoryTabsHeader
        shopsList={props.shopsList}
        selectedOption={props.selectedOption}
        setSelectedOption={option => props.setSelectedOption(option)}
        onSearch={onSearch}
        keyTab={props.keyTab}
        lowStock={props.lowStock}
        setLowStock={value => props.setLowStock(value)}
      />
      <InventoryTabsContent keyTab={props.keyTab} component={InventoryTable} selectedOption={props.selectedOption} searchText={searchText} lowStock={props.lowStock} />
    </div>
  )
}

export default InventoryTab

InventoryTab.defaultProps = {
  edit: {},
  shopsList: [],
}
